import * as endpoints from './endpoints';
import getProgramPeriods from './actions/getProgramPeriods';

const CarePeriodService = { ...endpoints, getProgramPeriods };

export default CarePeriodService;
export type { CarePeriod } from './endpoints';
